import { Seq, Iterable } from 'immutable';

const fromJSOrdered = object => Iterable.isIterable(object) || typeof object !== 'object' || object === null ? object : Array.isArray(object) ? Seq(object).map(fromJSOrdered).toList() : Seq(object).map(fromJSOrdered).toOrderedMap();

export default fromJSOrdered;